
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/referrals",
      function () {
        return require("private-next-pages/[lng]/referrals.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/referrals"])
      });
    }
  